
    <div class="base_analytics_section-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54"
            viewBox="0 0 54 54" fill="none">
            <rect width="54" height="54" rx="27" fill="#D7F3FF" />
            <path
                d="M24.6961 39.2316C25.4368 39.8618 26.2092 40.4378 27 41C27.7925 40.4453 28.5612 39.8552 29.3039 39.2316C30.542 38.1831 31.7072 37.0463 32.7909 35.8296C35.2891 33.0124 38 28.9285 38 24.3442C38 22.8545 37.7155 21.3793 37.1627 20.003C36.6099 18.6266 35.7996 17.376 34.7782 16.3226C33.7567 15.2692 32.5441 14.4336 31.2095 13.8635C29.8749 13.2934 28.4445 13 27 13C25.5555 13 24.1251 13.2934 22.7905 13.8635C21.4559 14.4336 20.2433 15.2692 19.2218 16.3226C18.2004 17.376 17.3901 18.6266 16.8373 20.003C16.2845 21.3793 16 22.8545 16 24.3442C16 28.9285 18.7109 33.0112 21.2091 35.8296C22.2928 37.0468 23.458 38.1827 24.6961 39.2316ZM27 28.4407C25.9465 28.4407 24.9362 28.0091 24.1912 27.2409C23.4463 26.4726 23.0278 25.4307 23.0278 24.3442C23.0278 23.2577 23.4463 22.2158 24.1912 21.4475C24.9362 20.6793 25.9465 20.2477 27 20.2477C28.0535 20.2477 29.0638 20.6793 29.8088 21.4475C30.5537 22.2158 30.9722 23.2577 30.9722 24.3442C30.9722 25.4307 30.5537 26.4726 29.8088 27.2409C29.0638 28.0091 28.0535 28.4407 27 28.4407Z"
                fill="#1AACD9" />
        </svg>
        <span  i18n="@@storefront_analytics.top_customers_location">Most popular end customer locations</span>
    </div>
    <div class="base_analytics_section-body">
        <div class="map-container">
            <agm-map
              #agmMap
              (mapReady)="onMapReady($event)"
              [latitude]="lat"
              [longitude]="lng"
              [fitBounds]="true"
              [zoom]="zoom">
          
				<div *ngIf="markers && markers.length > 0; else noMarkers">
					<agm-marker
					*ngFor="let m of markers"
					[latitude]="m.lat"
					[longitude]="m.lng"
					[agmFitBounds]="true">
					</agm-marker>
				</div>
				
				<ng-template #noMarkers>
					<p>No location found</p>
				</ng-template>
			</agm-map>
          </div>
    </div>

